import useResourcesByType from './useResourcesByType';

/**
 * Hook to fetch photo resources for a user
 * Follows the same pattern as other resource hooks in the web app
 * @param {string} useruuid - User UUID to fetch photos for
 * @param {boolean} shared - Whether to fetch shared photos (default: false for own gallery)
 * @returns {Object} Query result with data, isLoading, error
 */
const usePhotoResources = ({ useruuid, shared = false }) => {
  return useResourcesByType({
    useruuid,
    resourceType: 'photos',
    shared,
    details: true,
  });
};

export default usePhotoResources;
